var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("QuoteUI", {
    ref: "UI",
    attrs: {
      skin: _vm.skin,
      dataModel: _vm.dataModel,
      showLoading: _vm.showLoading,
      showPrePost: _vm.showPrePost,
      errorCode: _vm.error.code,
      settings: _vm.settings,
      labels: _vm.initedLabels,
      formatter: _vm.formatter
    },
    on: {
      track: _vm.trackEvent,
      "settings-changed": _vm.changeSettings,
      "settings-popover-hide": _vm.hideSettingsPopover
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }